import { required, minLength } from "@/validation/validators";

export const createDashboardSchema = () => ({
    dashboard: {
        name: { required, minLength: minLength(4) },
        platform: { required },
        user: { required },
    },
});
